// Tra khách quen theo tên / SĐT (GET /customers/suggest) — form tạo đơn dùng để nhận ra SĐT của khách
// đã lưu khi đang nhập khách lạ. Kèm nhãn số đơn / boom dùng chung cho danh bạ và trang Khách hàng.

import { useQuery } from "@tanstack/react-query"
import { get } from "@/lib/api"
import { cn } from "@/lib/utils"
import { useDebounced } from "@/hooks/useDebounced"
import type { SuggestCustomer } from "./types"

/** Đủ dài để tra: SĐT ≥ 3 số, tên ≥ 2 ký tự (khớp điều kiện của API). */
export function suggestEligible(q: string): boolean {
  const t = q.trim()
  if (!t) return false
  return /^[+\d\s().-]+$/.test(t) ? t.replace(/\D/g, "").length >= 3 : t.length >= 2
}

export function useCustomerSuggest(q: string, opts: { enabled: boolean; limit?: number }) {
  const debounced = useDebounced(q.trim(), 250)
  return useQuery({
    queryKey: ["customers", "suggest", debounced, opts.limit ?? 8],
    queryFn: () => get<{ customers: SuggestCustomer[] }>(`/customers/suggest?q=${encodeURIComponent(debounced)}&limit=${opts.limit ?? 8}`),
    enabled: opts.enabled && suggestEligible(debounced),
    staleTime: 30_000,
  })
}

export function CustomerBadges({ c, className }: { c: Pick<SuggestCustomer, "orderCount" | "boomCount" | "phone">; className?: string }) {
  return (
    <span className={cn("inline-flex flex-wrap items-center gap-1", className)}>
      {c.orderCount === 0 ? (
        <span className="rounded-full bg-paperSoft px-1.5 py-0.5 text-xs font-medium text-inkSoft">0 đơn</span>
      ) : c.phone ? (
        <span className="rounded-full bg-ok/12 px-1.5 py-0.5 text-xs font-medium text-ok">Khách quen · {c.orderCount} đơn</span>
      ) : (
        <span className="rounded-full bg-paperSoft px-1.5 py-0.5 text-xs font-medium text-inkSoft">{c.orderCount} đơn</span>
      )}
      {c.boomCount > 0 && <span className="rounded-full bg-danger/10 px-1.5 py-0.5 text-xs font-medium text-danger">Boom {c.boomCount}</span>}
    </span>
  )
}
